import HttpRequest from "./axios";
export default new HttpRequest();